module.exports = __webpack_public_path__ + "pc/img/logo-2.521cf1b7.png";